@if (form) {
    <div [formGroup]="form">
        <sirius-checkbox
            [id]="id"
            [name]="name"
            [label]="label"
            [checked]="checked"
            [formControlName]="name"
            [identifier]="identifier"></sirius-checkbox>
    </div>
}
